import { useQuery } from "@tanstack/react-query";
import type { Usuario } from "../../../shared/tipos";
import { api } from "./cliente";

export const chaves = {
  usuarios: ["usuarios"] as const,
};

export const useUsuarios = () =>
  useQuery({ queryKey: chaves.usuarios, queryFn: () => api<Usuario[]>("/api/usuarios") });
